module.exports = __webpack_public_path__ + "img/full3-min.be256cfb.png";